
import React, {FC, useCallback, memo} from 'react';
import styled from 'styled-components';
import colors from '../../../config/colors';

// Interface Props
interface Props {
  theme?: string;
  text?: any;
  onCheckboxChange: (value: any) => void;
  isChecked: boolean | undefined;
  name?: string;
  link?: string;
  linkedText?: string;
  required?: string;
  value?: string;
  disabled?: boolean;
  tooltip?: boolean;
  tooltipText?: any;
}

const CheckboxLg: FC<Props> = (props) => {

  const {text, link, linkedText, tooltip, tooltipText, required, isChecked, onCheckboxChange, name, value, disabled, theme} = props;

  const checkboxChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const {checked} = e.target;
    onCheckboxChange(checked);
  },[onCheckboxChange]);

  return (
    <Wrapper className={theme === 'white' ? 'whiteCheckbox' : ''}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={checkboxChange}
        name={name}
        disabled={disabled? disabled : false}
        value={value}
      />

      <span></span>{text} {link ? <u><a href={link} rel="noopener noreferrer" target="_blank">{linkedText}</a></u> :null} 
      <sup>{required}</sup>{/* this is label for checkbox */}

      {tooltip ?
        <TooltipIcon>
          <i>
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" enableBackground="new 0 0 330 330">
              <g>
                <path d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992
                  C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008
                  s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z"/>
                <path d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983
                  C180,136.725,173.284,130.008,165,130.008z"/>
                <path d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61
                  c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61
                  C172.81,71.61,168.95,70.011,165,70.011z"/>
              </g>
            </svg>
          </i>
        <div className="tooltip-info">{tooltipText}</div>
      </TooltipIcon>
      : null}
    </Wrapper>
  );
}

const Wrapper = styled.label`
  margin-bottom: 8px;

  sup {
    color: #ff0000;
    font-size: 12px;
    position: relative;
    margin-left: 5px;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 0;
    height: 0;
  }

  padding: 3px 0 0px 35px;
  cursor: pointer;
  user-select: none;
  display: table;
  position: relative;
  font-size: 14px;
  min-height: 25px;
  color: ${colors.BLACK_COLOR};

  &:hover {

    input ~ span {
     background-color: #e9e9f2;
    }
  }

  a {
    margin-left: 4px;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
    width: 25px;
    height: 25px;
    background-color: ${colors.GRAY_EXTRA_LIGHT};
    transition: background 100ms ease-in-out;
    margin-right: 8px;

    &:after {
      content: "";
      position: absolute;
      opacity: 0;
      left: 8px;
      top: 4px;
      width: 8px;
      height: 14px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      transition: opacity 200ms ease-in-out;
    }
  }

  input {

    &:checked ~ span {
      background-color: ${colors.PRIMARY_ORANGE};
    }

    &:checked ~ span:after {
      opacity: 1;
    }
  }

  &.whiteCheckbox {

    &:hover {

      input ~ span {
        background-color: ${colors.WHITE};
      }

      input:checked ~ span {
        background-color: ${colors.PRIMARY_ORANGE};
      }
    }

    span {
      background-color: ${colors.WHITE};
    }
  }
`;

Wrapper.defaultProps = {
  theme: 'primary'
}

const TooltipIcon = styled.div`
  position: absolute;
  right: -15px;
  top: 5px;

  &:hover {
    svg {
      fill: ${colors.ORANGE_COLOR};
    }
  }

  @media (max-width: 540px) {
    right: -8px;
  }

   svg {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: text-top;
   }
   .tooltip-info {
      visibility: hidden;
      border-radius: 6px;
      position: absolute;
      z-index: 1;
      width: 380px;
      background-color: rgb(255, 255, 255);
      border: 1px solid rgba(93, 93, 93, 0.16);
      box-shadow: rgb(93 93 93 / 16%) 0px 0px 20px;
      border-radius: 10px;
      text-align: justify;
      padding: 12px 10px;
      position: absolute;
      top: 50%;
      right: 25px;
      transform: translateY(-50%);
      z-index: 1;
      display: flex;
      transition: all 150ms ease-in-out 0s;
    }
    &:hover .tooltip-info {
    visibility: visible;
  }
`;


export default memo(CheckboxLg);
